import { Auth } from '../../actions';
import { StoreState } from '../../reducers';

export const selectAuth = (state: StoreState): Auth => state.auth;
